module.exports = {
          srcSet: __webpack_public_path__ + "public/images/f1e3fc6b838c2e208f68e78736c6b11c-1200.webp"+" 1200w",
          images:[ {path: __webpack_public_path__ + "public/images/f1e3fc6b838c2e208f68e78736c6b11c-1200.webp",width: 1200,height: 800}],
          src: __webpack_public_path__ + "public/images/f1e3fc6b838c2e208f68e78736c6b11c-1200.webp",
          toString:function(){return __webpack_public_path__ + "public/images/f1e3fc6b838c2e208f68e78736c6b11c-1200.webp"},
          
          width: 1200,
          height: 800
        }